/* istanbul ignore next */
const addAdditionalSearchStyles = (cssClassName) => {
  window.addsearch_settings = {
    results_box_css_classname: cssClassName,
  };
};

export default addAdditionalSearchStyles;
